var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4258 11.0952L4.42576 3.09517C4.25458 3.01462 4.06406 2.98428 3.87632 3.00768C3.68859 3.03108 3.51134 3.10725 3.36516 3.22735C3.21899 3.34745 3.10988 3.50656 3.05051 3.68619C2.99114 3.86582 2.98395 4.05861 3.02976 4.24217L4.24176 9.09117L11.9998 12.0002L4.24176 14.9092L3.02976 19.7582C2.98309 19.9419 2.98968 20.135 3.04877 20.3151C3.10787 20.4952 3.21702 20.6547 3.36346 20.7751C3.5099 20.8954 3.68757 20.9715 3.8757 20.9946C4.06382 21.0176 4.25461 20.9866 4.42576 20.9052L21.4258 12.9052C21.5976 12.8244 21.7428 12.6964 21.8446 12.5362C21.9463 12.3759 22.0004 12.19 22.0004 12.0002C22.0004 11.8103 21.9463 11.6244 21.8446 11.4642C21.7428 11.3039 21.5976 11.1759 21.4258 11.0952Z",
    fill: "#E6DE33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3586631067637526e2364387e5f79c4c.svg";
export { ForwardRef as ReactComponent };